import { render, staticRenderFns } from "./ordersTab.vue?vue&type=template&id=03f797d9&"
import script from "./ordersTab.vue?vue&type=script&lang=js&"
export * from "./ordersTab.vue?vue&type=script&lang=js&"
import style0 from "./ordersTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports